import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';

@Component({
    selector: 'app-loading-popup',
    templateUrl: './loading-popup.component.html',
    styleUrls: ['./loading-popup.component.css'],
    imports: [MatDialogActions]
})
/**
 * A popup that waits on a promise, displaying "Loading..". If the
 * promise resolves, then it closes. Otherwise the error is displayed.
 */
export class LoadingPopupComponent {
    private dialogRef = inject<MatDialogRef<LoadingPopupComponent>>(MatDialogRef);

    /** stillGoing: whether the popup should still show "Loading..." */
    public stillGoing = true;
    public errorMessage: string;
    public successMessage: string;

    /**
     * Constructs a new popup based on a given promise.
     */
    constructor() {
        const data = inject<{
            promise: Promise<unknown>;
            successMessage?: string;
        }>(MAT_DIALOG_DATA);

        data.promise
            .then(() => {
                if (data.successMessage) {
                    this.successMessage = data.successMessage;
                    this.stillGoing = false;
                } else {
                    setTimeout(() => this.dialogRef.close());
                }
            })
            .catch((error) => {
                this.errorMessage = error;
                this.stillGoing = false;
            });
    }

    /**
     * Closes the popup.
     */
    close(): void {
        this.dialogRef.close();
    }
}
